import Step from "./Step";
import Echo from 'laravel-echo';

class Step6 extends Step {
    constructor() {
        // Find the step element that contains the company creation loader
        const stepElement = $('[data-register-step="loader"]');
        super(7, 'loader', stepElement);

        // UI Elements
        this.backToOptionsBtn = $('#back_to_options');
        this.backOption = $('#back_option');
        this.funnySubtext = $('#funny_subtext');

        // Funny subtexts that rotate with associated animations
        this.funnyTexts = [
            { text: 'Even geduld, we bereiden alles voor...', animation: 'building' },
            { text: 'Even geduld, we zijn bezig met de magische ingrediënten...', animation: 'magic' },
            { text: 'We leren uw computer hoe geweldig u bent...', animation: 'gear' },
            { text: 'Onze hamsters rennen extra hard voor u...', animation: 'rocket' },
            { text: 'We kalibreren de success-o-meter...', animation: 'gear' },
            { text: 'Pixels worden zorgvuldig op hun plaats gezet...', animation: 'magic' },
            { text: 'De digitale bouwvakkers zijn hard aan het werk...', animation: 'building' },
            { text: 'We installeren extra vetkuifjes voor uw succes...', animation: 'rocket' },
            { text: 'Uw bedrijf krijgt de VIP behandeling...', animation: 'building' },
            { text: 'We poetsen de servers even op voor u...', animation: 'gear' },
            { text: 'Bits en bytes worden zorgvuldig gesorteerd...', animation: 'gear' },
            { text: 'De cloud wordt extra pluizig gemaakt...', animation: 'cloud' },
            { text: 'We testen of alles 200% perfect werkt...', animation: 'rocket' }
        ];

        this.currentTextIndex = 0;
        this.textRotationInterval = null;
        this.skipInProgress = false; // Track skip operation to prevent multiple calls
    }

    stepStarted() {
        console.log('Step6 started - resetting state');
        // Reset to initial state when step is entered
        this.showInitialLoadingState();

        // Check if user was in the middle of a skip process (page refresh handling)
        this.checkForOngoingSkip();

        super.stepStarted();
    }

    init() {
        console.log('Step6 initialized');
        this.attachEventHandlers();
        this.startTextRotation();
        this.showInitialLoadingState();

        // Auto-start company creation when landing on this step
        // This handles both the flow from Step 5 -> 6 and Payment -> Register -> Step 6
        this.skipDemo();
    }

    // Method to show initial loading state
    showInitialLoadingState() {
        console.log('Setting up initial loading state');
        // Show spinner
        $('.spinner-border').show();
        // Hide back option
        this.backOption.hide();
        // Set initial loading text and animation
        const initialItem = this.funnyTexts[0];
        this.funnySubtext.text(initialItem.text);
        this.switchAnimation(initialItem.animation);
        this.currentTextIndex = 0;
    }

    // Method to check for ongoing skip process (handles page refresh)
    checkForOngoingSkip() {
        const demoSkipped = localStorage.getItem('demo_skipped');
        const skipUserId = localStorage.getItem('skip_user_id');

        if (demoSkipped === 'true' && skipUserId) {
            console.log('Found ongoing skip process after page refresh, resuming...');
            this.funnySubtext.text('Uw bedrijf wordt aangemaakt...');
            this.listenForCompanyCreation(parseInt(skipUserId));
        }
    }

    // Method to explicitly start company creation process
    startCompanyCreation() {
        console.log('Starting company creation process...');
        this.createCompanyAPI();
    }

    // Main skip demo method - called from Step5 and Step6
    async skipDemo() {
        console.log('Step6.skipDemo called');

        // Prevent multiple skip calls
        if (this.skipInProgress) {
            console.log('Skip already in progress, ignoring call');
            return;
        }

        this.skipInProgress = true;

        try {
            console.log('Calling skip demo API...');
            const response = await API.post('/demo/skip');

            if (response && response.status === 'success') {
                console.log('Skip demo successful');

                // Store skip status in localStorage to handle page refresh
                localStorage.setItem('demo_skipped', 'true');
                localStorage.setItem('skip_user_id', response.user_id);

                // Update UI to show loading state
                this.showInitialLoadingState();
                this.funnySubtext.text('Uw bedrijf wordt aangemaakt...');

                // Start listening for completion
                this.listenForCompanyCreation(response.user_id);

            } else {
                throw new Error(response.message || 'Skip demo failed');
            }
        } catch (error) {
            console.error('Skip demo failed:', error);

            // Check if it's a 'in_progress' response (not actually an error)
            if (error.responseJSON && error.responseJSON.status === 'in_progress') {
                console.log('Company creation already in progress, starting listener from Step7...');

                // Store skip status in localStorage to handle page refresh
                localStorage.setItem('demo_skipped', 'true');
                localStorage.setItem('skip_user_id', error.responseJSON.user_id);

                // Update UI to show loading state
                this.showInitialLoadingState();
                this.funnySubtext.text('Uw bedrijf wordt aangemaakt...');

                // Start listening for completion using user_id from response
                this.listenForCompanyCreation(error.responseJSON.user_id);
                return; // Don't throw error, this is expected behavior
            }

            // Check if company already exists (e.g. from previous attempt)
            if (error.responseJSON && error.responseJSON.message && error.responseJSON.message.includes('al een bedrijf aangemaakt')) {
                console.log('Company already exists, redirecting to home...');
                this.showSuccess({ redirect: '/home' });
                return;
            }

            this.skipInProgress = false;

            // Show error message
            let errorMessage = 'Er is een fout opgetreden bij het overslaan van de demo';
            if (error.responseJSON && error.responseJSON.message) {
                errorMessage = error.responseJSON.message;
            }

            this.showError(errorMessage);

            throw error; // Re-throw so calling steps can handle it
        }
    }

    attachEventHandlers() {
        // Back to options (step congrats)
        this.backToOptionsBtn.off('click').on('click', (e) => {
            e.preventDefault();
            this.goToStep('congrats');
        });
    }

    startTextRotation() {
        // Start rotating the funny texts every 3 seconds
        this.textRotationInterval = setInterval(() => {
            this.currentTextIndex = (this.currentTextIndex + 1) % this.funnyTexts.length;
            const currentItem = this.funnyTexts[this.currentTextIndex];

            // Add fade out class for smooth transition
            this.funnySubtext.addClass('fade-out');

            setTimeout(() => {
                // Update text and animation
                this.funnySubtext.text(currentItem.text);
                this.switchAnimation(currentItem.animation);

                // Remove fade out and add fade in
                this.funnySubtext.removeClass('fade-out').addClass('fade-in');

                // Clean up fade class after animation
                setTimeout(() => {
                    this.funnySubtext.removeClass('fade-in');
                }, 300);
            }, 300);
        }, 3000);
    }

    stopTextRotation() {
        if (this.textRotationInterval) {
            clearInterval(this.textRotationInterval);
            this.textRotationInterval = null;
        }
    }

    switchAnimation(animationType) {
        // Hide all animation wrappers
        $('.svg-animation-wrapper').hide();

        // Show the selected animation
        const animationId = `${animationType}_animation`;
        $(`#${animationId}`).show();
    }

    async createCompanyAPI() {
        try {
            console.log('Creating company job...');
            // Ensure loading state is visible
            $('.spinner-border').show();
            this.backOption.hide();
            this.funnySubtext.text('Even geduld, uw bedrijf wordt aangemaakt...');

            const response = await API.post('/demo/skip');

            if (response && response.status === 'success') {
                console.log('Company creation job dispatched, waiting for completion...');
                this.listenForCompanyCreation(response.user_id);
            } else {
                throw new Error(response.message || 'Company creation failed');
            }
        } catch (error) {
            console.error('Company creation failed:', error);
            this.showError();
        }
    }

    listenForCompanyCreation(userId) {
        console.log('Listening for RegisterComplete event on channel register.' + userId);

        this.clearCompanyCreationTimeout();
        this.companyCreationTimeout = setTimeout(() => {
            console.warn('RegisterComplete event never arrived within timeout window');
            this.showError('Dit duurt langer dan verwacht. Probeer het opnieuw of neem contact op met support.');
        }, 45000);

        try {
            // Get or create Echo instance
            let echoInstance;

            if (window.Echo) {
                // Use existing global Echo instance
                echoInstance = window.Echo;
                console.log('Using existing window.Echo instance');
            } else {
                // Create new Echo instance if none exists
                console.log('Creating new Echo instance');
                if (typeof echo_options === 'undefined') {
                    throw new Error('Echo options not available');
                }

                // Parse echo_options if it's a string
                let parsedEchoOptions;
                if (typeof echo_options === 'string') {
                    try {
                        parsedEchoOptions = JSON.parse(echo_options);
                    } catch (error) {
                        throw new Error('Failed to parse echo_options: ' + error.message);
                    }
                } else {
                    parsedEchoOptions = echo_options;
                }

                console.log('Echo options:', parsedEchoOptions);
                echoInstance = new Echo(parsedEchoOptions);
                window.Echo = echoInstance;
            }

            // Listen for RegisterComplete events
            echoInstance.private(`register.${userId}`)
                .listen(`.RegisterComplete`, (e) => {
                    console.log('RegisterComplete event received:', e);

                    if (e.failed) {
                        this.showError();
                    } else {
                        this.showSuccess({ redirect: '/home' });
                    }
                });

        } catch (error) {
            console.error('Failed to set up Echo listener:', error);
            this.showError();
        }
    }

    clearCompanyCreationTimeout() {
        if (this.companyCreationTimeout) {
            clearTimeout(this.companyCreationTimeout);
            this.companyCreationTimeout = null;
        }
    }

    showSuccess(response) {
        console.log('Company creation successful:', response);

        this.clearCompanyCreationTimeout();

        // Stop text rotation
        this.stopTextRotation();

        // Clear localStorage flags
        localStorage.removeItem('demo_skipped');
        localStorage.removeItem('skip_user_id');

        // Update subtext to success message
        this.funnySubtext.text('Gefeliciteerd! Uw bedrijf is klaar. U wordt doorgestuurd...');

        // Redirect immediately without SweetAlert
        setTimeout(() => {
            window.location.href = response.redirect || '/home';
        }, 1500);
    }

    showError(customMessage = null) {
        console.log('Company creation failed');

        this.clearCompanyCreationTimeout();

        // Stop text rotation
        this.stopTextRotation();

        // Clear localStorage flags on permanent error
        localStorage.removeItem('demo_skipped');
        localStorage.removeItem('skip_user_id');

        // Reset skip flag to allow retry
        this.skipInProgress = false;

        // Update subtext to error message
        const errorMessage = customMessage || 'Er is iets misgegaan. Probeer het opnieuw.';
        this.funnySubtext.text(errorMessage);

        // Hide spinner and show back option
        $('.spinner-border').hide();
        this.backOption.show();
    }

    goToStep(stepNumber) {
        // Use the register's goNext method for proper step management
        if (window.register) {
            window.register.goNext(stepNumber);
        }
    }
}

export default Step6;